import { render } from "./alerts.vue?vue&type=template&id=664b5e98&scoped=true"
import script from "./alerts?vue&type=script&lang=js&external"
export * from "./alerts?vue&type=script&lang=js&external"

import "./alerts.vue?vue&type=style&index=0&id=664b5e98&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-664b5e98"]])

export default __exports__